export interface OrganizationFilterInput {
    searchTerm?: string;
    state?: string;
    status?: string;
    /** The organization id to narrow to (resolved from a chosen account/school). */
    schoolOrgId?: string;
}

/**
 * Resolve the parent organization (Tier 1 / District) id for a chosen account
 * (Tier 2 / School), so the organizations list can be filtered to it.
 */
export function resolveSchoolOrganizationId(
    accountId: string,
    accounts: { id: string; organization_id: string }[],
): string | undefined {
    if (!accountId) return undefined;
    return accounts.find(a => a.id === accountId)?.organization_id;
}

/**
 * Apply the organizations-list filters (search, state, status, and the
 * "filter by child school" narrowing) to a Supabase query builder. Kept as a
 * plain builder adapter so the filter mapping is unit-testable.
 */
export function applyOrganizationFilters(query: any, opts: OrganizationFilterInput): any {
    let q = query;
    if (opts.searchTerm) {
        q = q.or(`name.ilike.%${opts.searchTerm}%,administrator_email.ilike.%${opts.searchTerm}%`);
    }
    if (opts.state) q = q.eq('state', opts.state);
    if (opts.status) q = q.eq('status', opts.status);
    if (opts.schoolOrgId) q = q.eq('id', opts.schoolOrgId);
    return q;
}
